import { render, staticRenderFns } from "./TwoMonthDiscountOfferAccepted.vue?vue&type=template&id=64df71d1&scoped=true"
import script from "./TwoMonthDiscountOfferAccepted.vue?vue&type=script&lang=js"
export * from "./TwoMonthDiscountOfferAccepted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64df71d1",
  null
  
)

export default component.exports